import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { EventListResponse } from './Events.type';
import { AxiosResponse } from 'axios';

let listRequest: any = null;

export const eventsService = {
  getList: (params: {
    page?: number;
  }): Promise<AxiosResponse<EventListResponse>> => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    return axios.get(getEndpointBase('event/main-group'), {
      cancelToken: listRequest.token,
      params,
    });
  },
};
